module.exports = __webpack_public_path__ + "img/jobfair.01b58f66.png";